var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid"},[(_vm.type === 'admin')?_c('dashboard-admin'):_vm._e(),(_vm.type === 'coach')?_c('dashboard-coach'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }